export default __webpack_public_path__ + "static/datascienceServiceslogo-b0328e22fcc1f795c2708c43be74d627.svg";